enum Types {
  GET_BLOCKED_ENVIRONMENTS_REQUEST = 'GET_BLOCKED_ENVIRONMENTS_REQUEST',
  GET_BLOCKED_ENVIRONMENTS_FULFILLED = 'GET_BLOCKED_ENVIRONMENTS_FULFILLED',
  GET_BLOCKED_ENVIRONMENTS_REJECTED = 'GET_BLOCKED_ENVIRONMENTS_REJECTED',

  GET_ENVIRONMENT_HEALTH_REQUEST = 'GET_ENVIRONMENT_HEALTH_REQUEST',
  GET_ENVIRONMENT_HEALTH_FULFILLED = 'GET_ENVIRONMENT_HEALTH_FULFILLED',
  GET_ENVIRONMENT_HEALTH_REJECTED = 'GET_ENVIRONMENT_HEALTH_REJECTED',

  GET_INSTANCE_STATUS_REQUEST = 'GET_INSTANCE_STATUS_REQUEST',
  GET_INSTANCE_STATUS_FULFILLED = 'GET_INSTANCE_STATUS_FULFILLED',
  GET_INSTANCE_STATUS_REJECTED = 'GET_INSTANCE_STATUS_REJECTED',

  GET_ENVIRONMENT_AND_CELERY_QUEUE_STATUS_REQUEST = 'GET_ENVIRONMENT_AND_CELERY_QUEUE_STATUS_REQUEST',
  GET_ENVIRONMENT_AND_CELERY_QUEUE_STATUS_FULFILLED = 'GET_ENVIRONMENT_AND_CELERY_QUEUE_STATUS_FULFILLED',
  GET_ENVIRONMENT_AND_CELERY_QUEUE_STATUS_REJECTED = 'GET_ENVIRONMENT_AND_CELERY_QUEUE_STATUS_REJECTED',

  GET_ENVIRONMENTS_WITH_FAILED_ZERO_TRUST_REQUEST = 'GET_ENVIRONMENTS_WITH_FAILED_ZERO_TRUST_REQUEST',
  GET_ENVIRONMENTS_WITH_FAILED_ZERO_TRUST_FULFILLED = 'GET_ENVIRONMENTS_WITH_FAILED_ZERO_TRUST_FULFILLED',
  GET_ENVIRONMENTS_WITH_FAILED_ZERO_TRUST_REJECTED = 'GET_ENVIRONMENTS_WITH_FAILED_ZERO_TRUST_REJECTED',

  GET_SESSIONS_HISTORY_MONITOR_GRAPH_REQUEST = 'GET_SESSIONS_HISTORY_MONITOR_GRAPH_REQUEST',
  GET_SESSIONS_HISTORY_MONITOR_GRAPH_FULFILLED = 'GET_SESSIONS_HISTORY_MONITOR_GRAPH_FULFILLED',
  GET_SESSIONS_HISTORY_MONITOR_GRAPH_REJECTED = 'GET_SESSIONS_HISTORY_MONITOR_GRAPH_REJECTED',

  GET_CLIENTS_HISTORY_MONITOR_GRAPH_REQUEST = 'GET_CLIENTS_HISTORY_MONITOR_GRAPH_REQUEST',
  GET_CLIENTS_HISTORY_MONITOR_GRAPH_FULFILLED = 'GET_CLIENTS_HISTORY_MONITOR_GRAPH_FULFILLED',
  GET_CLIENTS_HISTORY_MONITOR_GRAPH_REJECTED = 'GET_CLIENTS_HISTORY_MONITOR_GRAPH_REJECTED',

  GET_USERS_HISTORY_MONITOR_GRAPH_REQUEST = 'GET_USERS_HISTORY_MONITOR_GRAPH_REQUEST',
  GET_USERS_HISTORY_MONITOR_GRAPH_FULFILLED = 'GET_USERS_HISTORY_MONITOR_GRAPH_FULFILLED',
  GET_USERS_HISTORY_MONITOR_GRAPH_REJECTED = 'GET_USERS_HISTORY_MONITOR_GRAPH_REJECTED',

  GET_ENVIRONMENTS_COST_MONITOR_GRAPH_REQUEST = 'GET_ENVIRONMENTS_COST_MONITOR_GRAPH_REQUEST',
  GET_ENVIRONMENTS_COST_MONITOR_GRAPH_FULFILLED = 'GET_ENVIRONMENTS_COST_MONITOR_GRAPH_FULFILLED',
  GET_ENVIRONMENTS_COST_MONITOR_GRAPH_REJECTED = 'GET_ENVIRONMENTS_COST_MONITOR_GRAPH_REJECTED',

  GET_MONTHLY_ENVIRONMENTS_COST_MONITOR_GRAPH_REQUEST = 'GET_MONTHLY_ENVIRONMENTS_COST_MONITOR_GRAPH_REQUEST',
  GET_MONTHLY_ENVIRONMENTS_COST_MONITOR_GRAPH_FULFILLED = 'GET_MONTHLY_ENVIRONMENTS_COST_MONITOR_GRAPH_FULFILLED',
  GET_MONTHLY_ENVIRONMENTS_COST_MONITOR_GRAPH_REJECTED = 'GET_MONTHLY_ENVIRONMENTS_COST_MONITOR_GRAPH_REJECTED',

  SET_PERIOD_FILTER_SESSIONS = 'SET_PERIOD_FILTER_SESSIONS',
  SET_PERIOD_FILTER_INSTANCES = 'SET_PERIOD_FILTER_INSTANCES',

  SET_PERIOD_CLIENT_HISTORY_FILTER = 'SET_PERIOD_CLIENT_HISTORY_FILTER',

  SET_PERIOD_FILTER_ENVIRONMENTS_COST = 'SET_PERIOD_FILTER_ENVIRONMENTS_COST',

  GET_FLAVORS_COST_MONITOR_REQUEST = 'GET_FLAVORS_COST_MONITOR_REQUEST',
  GET_FLAVORS_COST_MONITOR_FULFILLED = 'GET_FLAVORS_COST_MONITOR_FULFILLED',
  GET_FLAVORS_COST_MONITOR_REJECTED = 'GET_FLAVORS_COST_MONITOR_REJECTED',
  SET_FLAVORS_COST_MONITOR_PERIOD_FILTER = 'SET_FLAVORS_COST_MONITOR_PERIOD_FILTER',

  GET_FLAVOR_ENVIRONMENTS_REQUEST = 'GET_FLAVOR_ENVIRONMENTS_REQUEST',
  GET_FLAVOR_ENVIRONMENTS_FULFILLED = 'GET_FLAVOR_ENVIRONMENTS_FULFILLED',
  GET_FLAVOR_ENVIRONMENTS_REJECTED = 'GET_FLAVOR_ENVIRONMENTS_REJECTED',

  GET_INSTANCES_WITH_SESSION_TIMEOUT_REQUEST = 'GET_INSTANCES_WITH_SESSION_TIMEOUT_REQUEST',
  GET_INSTANCES_WITH_SESSION_TIMEOUT_FULFILLED = 'GET_INSTANCES_WITH_SESSION_TIMEOUT_FULFILLED',
  GET_INSTANCES_WITH_SESSION_TIMEOUT_REJECTED = 'GET_INSTANCES_WITH_SESSION_TIMEOUT_REJECTED',
}

export default Types;
